<template>
  <span class="skeleton" :class="`skeleton--${variant}`" :style="style"></span>
</template>

<script>
export default {
  name: 'VSkeleton',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '16px',
    },
    variant: {
      type: String,
      default: 'rect',
      validator: value => ['rect', 'text', 'circle'].includes(value),
    },
  },
  computed: {
    style() {
      return { width: this.width, height: this.height };
    },
  },
};
</script>

<style scoped lang="scss">
.skeleton {
  display: inline-block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef0f5 25%, #f7f8fb 37%, #eef0f5 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;

  &--circle {
    border-radius: 50%;
  }
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
